var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 1.75C3.66421 1.75 4 2.08579 4 2.5V15.25C4 15.5261 4.22386 15.75 4.5 15.75H17.5C17.9142 15.75 18.25 16.0858 18.25 16.5C18.25 16.9142 17.9142 17.25 17.5 17.25H4.5C3.39543 17.25 2.5 16.3546 2.5 15.25V2.5C2.5 2.08579 2.83579 1.75 3.25 1.75ZM16.9697 4.46967C17.2626 4.17678 17.7374 4.17678 18.0303 4.46967C18.3232 4.76256 18.3232 5.23744 18.0303 5.53033L13.0303 10.5303C12.7374 10.8232 12.2626 10.8232 11.9697 10.5303L9.5 8.06066L6.53033 11.0303C6.23744 11.3232 5.76256 11.3232 5.46967 11.0303C5.17678 10.7374 5.17678 10.2626 5.46967 9.96967L8.96967 6.46967C9.26256 6.17678 9.73744 6.17678 10.0303 6.46967L12.5 8.93934L16.9697 4.46967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsIcon);
export default __webpack_public_path__ + "static/media/results-icon.23818a51c23c2ea11c87176fc1f64d73.svg";
export { ForwardRef as ReactComponent };